import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';
import Modal from 'react-bootstrap-modal';

import 'sass/modals/modalBecomeXXL.scss';

import {t, dt} from 'l10n';
import {getPaymentUrl, getReturnPath} from '../../utils/url';

class ModalBecomeXXL extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    closeFn = e => {
        e.stopPropagation();
        this.props.closeFn();
    }

    render() {
        let {show} = this.props;

        if (!show) return null;

        let returnPath = getReturnPath();

        return (
            <Modal className="modalBecomeXXL" show={show} onHide={this.closeFn}>
                <Modal.Body>
                    <div className="close" onClick={this.closeFn}/>

                    <div className="banner" dangerouslySetInnerHTML={{__html: dt('xxl', '<span class="XXL">XXL</span> Membership')}}/>

                    <p className="text">{t('You need to become XXL to use this feature.')}</p>

                    <div className="form">
                        <div className="form-group">
                            <div className="buttons">
                                <Link to={getPaymentUrl(returnPath)} className="become-xxl">{t('Become XXL member')}</Link>
                                <a className="close" onClick={this.closeFn}>{t('Close')}</a>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

export default ModalBecomeXXL;


// WEBPACK FOOTER //
// ./src/components/modals/ModalBecomeXXL.js